import { render, staticRenderFns } from "./TilesGrid.vue?vue&type=template&id=38636fbb&scoped=true"
import script from "./TilesGrid.vue?vue&type=script&lang=js"
export * from "./TilesGrid.vue?vue&type=script&lang=js"
import style0 from "./TilesGrid.vue?vue&type=style&index=0&id=38636fbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38636fbb",
  null
  
)

export default component.exports